// @story HIR-HD5
// A vacancy's top 3 (server: services/roundViews.service.js): the three
// highest totals among candidates who have finished every round and are
// recommended. Worked out each time it is read, so an HR fail takes someone
// off at once. Shown to HR on the role's Rounds tab and to the Head on the
// shortlist; the server decides who may see it.
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { StatusPill } from "../../ds";
import { Section, Note } from "../../components/page";

const muted = { color: "var(--text-muted)", fontSize: "var(--fs-caption)" };

export default function TopThree({ jobId }) {
  const [st, setSt] = useState({ phase: "loading" });
  useEffect(() => {
    let live = true;
    api.get(`/round-views/vacancies/${jobId}/top-three`)
      .then((r) => { if (live) setSt({ phase: "ready", ...r.data.data }); })
      .catch((e) => { if (live) setSt({ phase: "error", message: e?.response?.data?.message || "The top 3 could not be read just now." }); });
    return () => { live = false; };
  }, [jobId]);

  if (st.phase === "loading") return null;
  return (
    <Section title="Top 3" subtitle="Finished and recommended candidates only, highest total first. Ties break on the registration number.">
      {st.phase === "error" ? <Note tone="warning">{st.message}</Note>
        : !st.ok ? <Note tone="info">{st.refusal}</Note>
          : !st.top.length ? <Note tone="info">Nobody has finished every round and been recommended yet.</Note>
            : (
              <ol style={{ margin: 0, paddingLeft: 20, display: "grid", gap: 6 }} data-testid="top-three">
                {st.top.map((t) => (
                  <li key={t.candidateId} style={{ fontSize: "var(--fs-body-sm)", color: "var(--text-1)" }}>
                    <span style={{ fontWeight: 600 }}>{t.name}</span>{" "}
                    <span className="num">{t.total}</span><span style={muted}> / 100</span>{" "}
                    {t.grade && <StatusPill tone="success">Grade {t.grade}</StatusPill>}{" "}
                    <span style={muted}>Ref. {t.reference}</span>
                  </li>
                ))}
              </ol>
            )}
      {st.phase === "ready" && st.ok && <div style={{ ...muted, marginTop: 8 }}>{st.eligible} of {st.considered} candidates have finished and are recommended.</div>}
    </Section>
  );
}
